import { render, staticRenderFns } from "./projectDialogCard.vue?vue&type=template&id=d1ffd38c"
import script from "./projectDialogCard.vue?vue&type=script&lang=js"
export * from "./projectDialogCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports